
import { Box } from '@mui/system';
import {RichTextInput} from 'ra-input-rich-text';
import * as React from 'react';
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
} from 'react-admin';

export default function ResourceEdit(props:any) {
  return (
    <Box style={styles.boxStyle}>
      <Edit sx={styles.editStyle} {...props}>
        <SimpleForm>
        <TextInput source="name"  sx={styles.inputStyle} /><TextInput source="email"  sx={styles.inputStyle} /><TextInput source="password"  sx={styles.inputStyle} /><TextInput source="personalNumber"  sx={styles.inputStyle} /><BooleanInput source="isActive"  sx={styles.inputStyle} /><TextInput source="telephone"   sx={styles.inputStyle}/>
      <ReferenceInput label={'Role'} source="roleId" reference="role">
    <SelectInput optionText="name" />
      </ReferenceInput>
      
      <ReferenceInput label={'Membership'} source="membershipId" reference="membership">
    <SelectInput optionText="name" />
      </ReferenceInput>
      
        </SimpleForm>
      </Edit>
    </Box>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  editStyle: {
    width: '50%',
    minWidth:200
  },
  inputStyle: {
    width: '100%',
  },
};

    